module.exports = __webpack_public_path__ + "img/h3.0ef9831d.png";